import { User } from '@/types/user'
import { Mutation } from 'vuex'
import { UserState } from '../types'

const setUserState: Mutation<UserState> = (state, user: User) => {
  state.current = Object.freeze(user)
}

export default setUserState
